import { CommodityMilestone } from '@bechtel/types';

export interface WorkListDetailButtonProps {
  onWorkListMenuSelect: (workListMenuType: WorkListMenuType) => void;
  milestone: CommodityMilestone;
  isPendingList?: boolean;
}

export enum WorkListMenuType {
  COMMODITY_DETAIL = 'COMMODITY_DETAIL',
  WORK_PACKAGE = 'WORK_PACKAGE',
  CREATE_BLOCK = 'CREATE_BLOCK',
  ADD_VIEW_PHOTOS = 'ADD_VIEW_PHOTOS',
}

export interface WorkListMenu {
  label: string;
  type: WorkListMenuType;
}
